
import Input from 'ui-kit/src/components/form/Input';

export default {
    extends: Input,

    props: {
        value: Object,
        what: String,
        filterFn: Function,
        labelFn: {
            type: [String, Function],
            default: 'name',
        },
        processFn: Function,
        noDetail: Boolean,
        isDirty: Boolean,
    },

    computed: {
        filteredOptions() {
            return $[this.what].filter(this.combinedFilterFn);
        },
        processedOptions() {
            return this.processFn ? this.processFn(this.filteredOptions) : this.filteredOptions;
        },
        detail() {
            return this.model && $.getDetail(types[this.what].pageName, this.model.id);
        },
        confirmDialogProps() {
            return !this.isDirty ? undefined : {
                title: this.$t(`confirm.goToDetail.title.${this.what}`),
                message: this.$t(`confirm.goToDetail.message`),
            };
        },
    },

    methods: {
        combinedFilterFn(item) {
            return (
                !item.archived &&
                (!this.filterFn || this.filterFn(item))
            );
        },
        getLabel(item) {
            return item.id && typeof this.labelFn === 'function' ? this.labelFn(item) : $.get(item, this.labelFn);
        },
    },
};
